import { render, staticRenderFns } from "./EmployeeIbanField.vue?vue&type=template&id=4fb2dcff&"
import script from "./EmployeeIbanField.vue?vue&type=script&lang=js&"
export * from "./EmployeeIbanField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports